import Video from "@components/cms/Video/Video";
import { specificBlockOptions } from "@components/cmsBlocks/configs";
import { isVideoExtension, isImageExtension } from "@config/config";
import { useMediaQuery } from "@hooks/useMediaQuery";

import s from "./HeroBlock.module.scss";

const Background = ({
  blockBackgroundImage: desktopMediaUrl,
  blockBackgroundImageMobile: mobileMediaUrl,
  backgroundOption,
}) => {
  const { isMobile } = useMediaQuery();

  const isDefaultBackgroundPosition =
    backgroundOption?.value ===
    specificBlockOptions.hero.backgroundOption.options[0].value;

  const getBackgroundUrl = () => {
    if (isMobile) {
      if (mobileMediaUrl) {
        return mobileMediaUrl;
      }
      return desktopMediaUrl || "";
    } else {
      return desktopMediaUrl || "";
    }
  };

  const mediaUrl = getBackgroundUrl();
  const isVideo = isVideoExtension(mediaUrl);
  const isImage = isImageExtension(mediaUrl);

  const getBackgroundStyle = () => {
    if (!mediaUrl) {
      return `linear-gradient(90deg, #000000d9, transparent)`;
    }

    if (isVideo) {
      return `linear-gradient(90deg, #000000d9, transparent)`;
    }

    if (isImage) {
      return `linear-gradient(90deg, #000000d9, transparent), url(${mediaUrl})`;
    }

    return `linear-gradient(90deg, #000000d9, transparent)`;
  };

  const videoSrc = isMobile
    ? mobileMediaUrl || desktopMediaUrl
    : desktopMediaUrl;

  return (
    <>
      {isVideo && (
        <div className={s.videoWrapper}>
          <Video videoSrc={videoSrc} />
        </div>
      )}
      <div
        className={s.overlay}
        style={{
          backgroundImage: getBackgroundStyle(),
          ...(isDefaultBackgroundPosition || isMobile
            ? {
                backgroundPosition: "center",
                backgroundSize: "cover",
              }
            : {
                backgroundPosition: "right",
                backgroundSize: "auto 100%",
              }),
        }}
      />
    </>
  );
};

export default Background;
